import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





'use strict';





var helpers = {

    select: function(data) {
        var requiredAttrs = ["id"],
            reservedAttrs = ["type", "data-mask", "data-gis-mask"],
            combinableAttrs = {
                "class": "spa-input-select",
                "value": "",
                "onchange": "this.setAttribute(\'data-val\', this.value);",
                "data-val": ""
            },
            attrsStr,
            optionsString = "",
            output,
            empty = true;

        if (!Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).pass) {

            throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).missingField);


            if (window.console && console.log) {
                console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).missingField);
                return "";
            }
        }
        Handlebars.helpers.removeReservedAttrs(data.select.attrs, reservedAttrs);
        Handlebars.helpers.combineAttrs(data.select.attrs, combinableAttrs);
        attrsStr = Handlebars.helpers.buildAttrsString(data.select.attrs);

        if (typeof data.select.attrs.noEmptyOption === 'undefined' || data.select.attrs.noEmptyOption === false) {
            optionsString = '<option value="">&nbsp;</option>';
            empty = false;
        }

        for (var i = 0, len = data.select.options.length; i < len; i++) {
            var option = data.select.options[i];
            optionsString += '<option value="' + option.value + '" ' + ((option.selected) ? "selected" : "") + '>' + option.text + '</option>';

            if (option.selected) {
                empty = false;
            }
        }

        output = '<div class="spa-input spa-input-box spa-dropdown spa-input--' + ((data.skin) ? data.skin : 'material-design') + (empty ? ' spa-input--empty' : '') + ((data.containerClasses) ? (' ' + data.containerClasses.join(' ')) : '') + '"> \
                  <label class="spa-input-label" for="' + data.select.attrs.id + '">' + data.label.text + ((data.required) ? '<span class="spa-input-label--required"> *</span>' : '') + '<span class="ada-hidden"> ' + ((data.label.adaText) ? data.label.adaText : '') + '</span></label> \
                  <select ' + attrsStr + ' ' + ((data.required) ? 'required' : '') + '>' + optionsString +
            '</select> \
                  <p class="spa-input-hint">' + ((data.hintText) ? data.hintText : '') + '</p> \
                </div>';

        return new Handlebars.SafeString(output);
    }
};



module.exports.register = function(Handlebars, options) {
    options = options || {};
    for (var helper in helpers) {
        if (helpers.hasOwnProperty(helper)) {
            Handlebars.registerHelper(helper, helpers[helper]);
        }
    }
};


module.exports.helpers = helpers;
